import dtImageOrigin from './dtImageOrigin';

import isDuitangImage from './isDuitangImage';

import dtImageSquare from './dtImageSquare';

import dtImageThumb from './dtImageThumb';

import dtImageSquareNoWebp from './dtImageSquareNoWebp';

import dtImageThumbNoWebp from './dtImageThumbNoWebp';

import dtImageNoWebp from './dtImageNoWebp';

import dtImageThumbOnlyNoWebpForGif from './dtImageThumbOnlyNoWebpForGif';

import dtImageSquareOnlyNoWebpForGif from './dtImageSquareOnlyNoWebpForGif';

import dtThumb from './dtThumb';

import dtSquare from './dtSquare';

import verifyImageAccessibility from './verifyImageAccessibility';

import getPrivateUrlOfImages from './getPrivateUrlOfImages';

import uploadImage from './uploadImage';

const DtImageTools = {
  dtImageOrigin,
  isDuitangImage,
  dtImageSquare,
  dtImageThumb,
  dtImageSquareNoWebp,
  dtImageThumbNoWebp,
  dtImageNoWebp,
  dtImageThumbOnlyNoWebpForGif,
  dtImageSquareOnlyNoWebpForGif,
  dtThumb,
  dtSquare,
  verifyImageAccessibility,
  getPrivateUrlOfImages,
  uploadImage,
};

export {
  dtImageOrigin,
  isDuitangImage,
  dtImageSquare,
  dtImageThumb,
  dtImageSquareNoWebp,
  dtImageThumbNoWebp,
  dtImageNoWebp,
  dtImageThumbOnlyNoWebpForGif,
  dtImageSquareOnlyNoWebpForGif,
  dtThumb,
  dtSquare,
  verifyImageAccessibility,
  getPrivateUrlOfImages,
  uploadImage,
};

export default DtImageTools;
